(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const controllers = new WeakMap()

    const initialize = (container) => {
      container.querySelectorAll('[data-announcement-controlled-autoplay]').forEach((carousel) => {
        if (controllers.has(carousel)) return

        const nextButton = carousel.querySelector('[data-direction="next"]')
        const toggle = carousel.querySelector('[data-announcement-autoplay-toggle]')
        if (!nextButton || !toggle) return

        const configuredInterval = Number(carousel.dataset.announcementAutoplayInterval) * 1000
        const interval = Number.isFinite(configuredInterval) && configuredInterval > 0 ? configuredInterval : 5000
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
        let userPaused = reducedMotion.matches
        let accessibilityPaused = document.body.classList.contains('Sea-Accessibility-stop_animations')
        let timer

        const isPaused = () => userPaused || accessibilityPaused

        const updateToggle = () => {
          const paused = isPaused()

          toggle.disabled = accessibilityPaused
          toggle.setAttribute('aria-pressed', String(paused))
          toggle.setAttribute(
            'aria-label',
            accessibilityPaused
              ? toggle.dataset.accessibilityPauseLabel
              : userPaused
                ? toggle.dataset.resumeLabel
                : toggle.dataset.pauseLabel
          )
          toggle.querySelector('[data-announcement-pause-icon]').hidden = paused
          toggle.querySelector('[data-announcement-play-icon]').hidden = !paused
        }

        const stop = () => {
          window.clearTimeout(timer)
          timer = undefined
        }

        const schedule = () => {
          stop()
          if (isPaused() || document.hidden) return
          timer = window.setTimeout(() => {
            nextButton.click()
            schedule()
          }, interval)
        }

        const handleToggle = () => {
          if (accessibilityPaused) return
          userPaused = !userPaused
          updateToggle()
          schedule()
        }

        const handleManualNavigation = () => {
          if (!isPaused()) schedule()
        }

        const handleReducedMotion = (event) => {
          userPaused = event.matches
          updateToggle()
          schedule()
        }

        const handleAccessibilityPause = () => {
          const nextAccessibilityPaused = document.body.classList.contains(
            'Sea-Accessibility-stop_animations'
          )
          if (accessibilityPaused === nextAccessibilityPaused) return

          accessibilityPaused = nextAccessibilityPaused
          updateToggle()
          schedule()
        }

        const handleVisibilityChange = () => schedule()
        const accessibilityObserver = new MutationObserver(handleAccessibilityPause)

        toggle.addEventListener('click', handleToggle)
        carousel.querySelectorAll('[data-direction]').forEach((button) => {
          button.addEventListener('click', handleManualNavigation)
        })
        reducedMotion.addEventListener('change', handleReducedMotion)
        document.addEventListener('visibilitychange', handleVisibilityChange)
        accessibilityObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ['class'],
        })

        controllers.set(carousel, {
          destroy: () => {
            stop()
            accessibilityObserver.disconnect()
            toggle.removeEventListener('click', handleToggle)
            carousel.querySelectorAll('[data-direction]').forEach((button) => {
              button.removeEventListener('click', handleManualNavigation)
            })
            reducedMotion.removeEventListener('change', handleReducedMotion)
            document.removeEventListener('visibilitychange', handleVisibilityChange)
          },
        })

        updateToggle()
        schedule()
      })
    }

    const destroy = (container) => {
      container.querySelectorAll('[data-announcement-controlled-autoplay]').forEach((carousel) => {
        controllers.get(carousel)?.destroy()
        controllers.delete(carousel)
      })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true })
    } else {
      initialize(document)
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target))
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target))
  })()

  } catch(e) { console.error(e); }
})();
})();
